"use client";

import { Carousel, CarouselProperties } from "@jesus-central-church/ui";
import {
  SbBlokData,
  storyblokEditable,
  StoryblokServerComponent,
} from "@storyblok/react/rsc";
import { SbCarousel } from "@storyblok/types/287435740670216/storyblok-components";

// Removed unused imports

export function CarouselComponent({
  blok,
  pageData,
}: {
  blok: SbCarousel;
  pageData: { locale: string };
}) {
  if (!blok.bloks || blok.bloks.length === 0) {
    return null;
  }

  const settings: CarouselProperties = {
    dots: blok.dots ?? true,
    infinite: blok.infinite ?? true,
    speed: blok.speed ? Number.parseInt(blok.speed) : 500,
    slidesToShow: blok.slidesToShow ? Number.parseInt(blok.slidesToShow) : 1,
    slidesToScroll: blok.slidesToScroll
      ? Number.parseInt(blok.slidesToScroll)
      : 1,
    centerMode: blok.centerMode ?? true,
    centerPadding: "10%",
    autoplay: blok.autplay ?? true,
    autoplaySpeed: blok.autoplayInterval
      ? Number.parseInt(blok.autoplayInterval)
      : 5000,
    swipeToSlide: blok.swipeToSlide ?? true,
    draggable: blok.draggable ?? true,
    arrows: blok.arrows ?? false,
    cssEase: "cubic-bezier(0.4, 0, 0.2, 1)",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          centerPadding: "8%",
        },
      },
      {
        breakpoint: 768,
        settings: {
          centerPadding: "5%",
        },
      },
      {
        breakpoint: 640,
        settings: {
          centerPadding: "3%",
        },
      },
    ],
    beforeChange: () => {
      // Optional: Add any logic before slide change
    },
    afterChange: () => {
      // Optional: Add any logic after slide change
    },
  };

  return (
    <Carousel {...storyblokEditable(blok as SbBlokData)} {...settings}>
      {blok.bloks?.map((blok) => (
        <StoryblokServerComponent
          key={blok._uid}
          blok={blok}
          pageData={pageData}
        />
      ))}
    </Carousel>
  );
}
